import React from 'react';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import { Card, CardBody, StatusPill, TableScroll } from '../../PanelComerciales.styles';
import SectionHeader from '../SectionHeader/SectionHeader';
import Pagination from '../Pagination/Pagination';
import { NotificationsPage } from 'src/redux/panel_comerciales/panel_comerciales.types';

interface NotificationsTableProps {
    page: NotificationsPage;
    loading: boolean;
    onLoadPage: (offset: number) => void;
}

/** severity del backend (INFO/ATENCION/URGENTE) → variante del pill. */
const VARIANT: Record<string, 'success' | 'warning' | 'danger' | 'muted'> = {
    INFO: 'success',
    ATENCION: 'warning',
    URGENTE: 'danger',
};

const fmtDate = (iso: string | null): string =>
    iso ? iso.slice(0, 16).replace('T', ' ') : '—';

const NotificationsTable: React.FC<NotificationsTableProps> = ({
    page,
    loading,
    onLoadPage,
}) => (
    <Card>
        <SectionHeader
            title='Notificaciones del sistema'
            subtitle='Alertas automáticas de metas, capacidad y actividad (solo lectura).'
            icon={<NotificationsActiveOutlinedIcon style={{ color: '#EF4444' }} />}
            actions={
                <Pagination
                    total={page.total}
                    limit={page.limit}
                    offset={page.offset}
                    onChange={onLoadPage}
                    disabled={loading}
                    label='de notificaciones'
                />
            }
        />
        <CardBody>
            <TableScroll>
                <table>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Severidad</th>
                            <th>Equipo</th>
                            <th>Mensaje</th>
                        </tr>
                    </thead>
                    <tbody>
                        {page.items.map((n) => (
                            <tr key={n.id}>
                                <td style={{ whiteSpace: 'nowrap' }}>{fmtDate(n.triggeredAt)}</td>
                                <td>
                                    <StatusPill $variant={VARIANT[n.severity ?? ''] ?? 'muted'}>
                                        {n.severity ?? n.alertCode ?? '—'}
                                    </StatusPill>
                                </td>
                                <td>{n.team ?? '—'}</td>
                                <td>{n.message ?? '—'}</td>
                            </tr>
                        ))}
                        {page.items.length === 0 && (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center', padding: 24, color: '#9CA3AF' }}>
                                    Sin alertas por ahora.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </TableScroll>
        </CardBody>
    </Card>
);

export default NotificationsTable;
